import { Event } from 'interfaces/sportsbook-data-levels';

export const createOddType = (
  event: Event,
  { team1, team2 }: { team1: string; team2: string },
  groupName = ''
): string => {
  const mapObj: Record<string, string> = {
    w1: team1,
    w2: team2,
    p1: team1,
    p2: team2,
    team1: team1,
    team2: team2
  };

  const name = event?.name?.replace(
    /w1|w2|p1|p2|team1|team2/gi,
    (matched: string) => mapObj[matched?.toLowerCase()]
  );

  let title = `${name}${event.base ? ` (${event.base})` : ''}`;

  if (groupName?.toLowerCase().includes('handicap')) {
    title = `(${event.base ? event.base : '0'})`;
  }

  return title;
};
